const configureExperimentsFullstory = experiments => {
  const fullstoryExperiments = [];
  experiments.forEach(x => {
    fullstoryExperiments.push(`${x.experimentKey} : ${x.bucketKey}`);
  });

  return fullstoryExperiments;
};

export default configureExperimentsFullstory
